module.exports = __webpack_public_path__ + "static/media/i-ending hokjønn.0497328e.mp3";